import { Component, OnInit } from '@angular/core';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.page.html',
  styleUrls: ['./invoices.page.scss'],
})
export class InvoicesPage implements OnInit {
  route = '/invoice/form';
  public config = {
    imageField: 'photo',
    imageField2: 'image',
    imageDefault: 'https://firebasestorage.googleapis.com/v0/b/gnx-aliados-corona-prd.appspot.com/o/defaults%2Fdefaults%2Farchive-el-vector-del-icono-aislado-en-fondo-blanco-muestra-fichero-134059140.jpeg?alt=media&token=8f42474c-7347-4ad1-b1e2-5ede5f4ed8f3',
    fields: [
      { label: 'Número: ', key: 'id' },
      { label: 'Total: ', key: 'total' },
    ],
  };

  constructor(
    private router: Router,
    public languageService: LanguagesService,
    public platform: Platform
  ) { }

  ngOnInit() {
    if(this.platform.is("desktop")){
      this.route = '/app/invoice/form';
    }
  }

  public viewMore({ detail: { id } }) {
    this.resetDates();
    this.router.navigate(['app/invoice', 'detail', id]);
  }

  get getTextsIUPageInvoices() {
    return this.languageService.textsIU.page_invoices;
  }

  resetDates() {
    let datesFilterStart = (document.getElementById("datesFilterStart") as HTMLInputElement)
    if( datesFilterStart?.value ) datesFilterStart.value = "";
    let datesFilterEnd = (document.getElementById("datesFilterEnd") as HTMLInputElement)
    if(datesFilterEnd?.value) datesFilterEnd.value = "";
  }
  goToAdd(){
    this.resetDates();
    this.router.navigate(['/app/invoice/form/']);
  }
}
